export default __webpack_public_path__ + "static/media/pencil_icon.57fb7aa1.svg";